<div *ngIf="showContent" class="container vertical-center d-grid animated fadeIn">
  <div class="jumbotron-fluid vertical-center row">
    <div class="frame frame-login center-block">
      <div class="row">
        <img style="position: relative;" class="center-block" src="assets/images/login/Frame.png" />
        <img
        style="position: absolute;"
          class="logo-login"
          src="assets/images/login/logo-bf-vertical.png"
          />
      </div>
      <div class="row row-title text-center">
        <h3 class="title secondary">Login</h3>
        <label class="subtitle">Selecciona el tipo de cuenta para hacer login</label>
      </div>
      <div class="row row-buttons">
        <div class="col-md-6">
          <div class="button-client">
            <div class="row content-button" >
              <div class="col-md-3 text-center col-checkbox">
                <input
                  type="radio"
                  name="client"
                  class="checkbox"
                  (click)="navigate('company')"
                  value="client"
                />
  
              </div>
              <div class="col-md-9 label-client secondary">
                Ingreso Empresa
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="button-executive">
            <div class="row content-button" >
              <div class="col-md-3 text-center col-checkbox">
                <input
                  type="radio"
                  name="executive"
                  class="checkbox"
                  (click)="navigate('executive')"
                  value="executive"
                />
  
              </div>
              <div class="col-md-9 label-client secondary">
                Ingreso Banco
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
